/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { Box, Stack, MenuItem } from '@mui/material';
import { useApi } from '../../../hooks/userApi';
import { useNavigate } from 'react-router-dom';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import { PaginationComponent } from '../../../components/tables/footerTableAction/footerTableAction-style';
import BtnPesquisa from '../../../components/BtnPesquisa/BtnPesquisa';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import TableComponente from 'components/tables/TableComponente/TableComponente.component';
import { TSelect } from 'styles/ListaClientes/ListaClientes.style';

const api = useApi();

const TabelaClientes = ({ vendedor, limit, page, like, setPageTotal, handchanceCliente }) => {
  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);
  const [clientes, setClientes] = useState([]);
  const headerTable = ['Nome do Cliente', 'CPF/CNPJ', 'Localização', 'Ação'];

  useEffect(() => {
    setLoading(true);
    api
      .get('cliente/vendedor/' + vendedor + `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}`)
      .then((r) => {
        if (!r.status) {
          setLoadingMensagem('Erro ao carregar página.');
          setLoadingBtn('OK');
          return;
        }
        setPageTotal(r.page_total);
        setClientes(r.results);
        setLoading(false);
      })
      .catch((e) => {
        const msg = 'Houve um erro interno, tente mais tarde.  (' + e.response.status + ')';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  }, [vendedor, page, like]);

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: row?.cpfCNPJ || '-', onClick: null, link: false },
          { campo: row?.estado, onClick: null, link: false },
          { campo: '+ Novo Orçamento', onClick: () => handchanceCliente(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  return (
    <>
      <TableComponente table={headerTable} data={formataTable(Object(clientes).length > 0 ? clientes : [])} />
    </>
  );
};

const SelectVendedor = (props) => {
  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);
  const [vendedores, setVendedores] = useState([props.user]);

  if (props.user.permissions.includes('Admin')) {
    useEffect(() => {
      setLoading(true);
      api
        .get('vendedor')
        .then((r) => {
          if (!r.status) {
            setLoadingMensagem('Desculpe ocorreu um erro!');
            setLoadingBtn('OK');
            return;
          }
          setLoading(false);
          setVendedores(r.results);
        })
        .catch((e) => {
          const msg = 'Houve um erro interno, tente mais tarde.  (' + e.response.status + ')';

          setLoadingMensagem(msg);
          setLoadingBtn('OK');
        });
    }, []);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'end !important',
        flexWrap: 'wrap',
        p: 1,
        m: 1,
      }}
    >
      <TSelect
        select
        id="standard-select-currency-native"
        label="Vendedor"
        defaultValue={props.vendedor}
        onChange={props.handleChangeVendedor}
      >
        {vendedores.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.nome}
          </MenuItem>
        ))}
      </TSelect>
      <BtnPesquisa handleLike={props.handleLike} />
    </Box>
  );
};

const ListaClientes = () => {
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [vendedor, setVendedor] = React.useState(user.id);
  const [page, setPage] = useState(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [limit, setLimit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [like, setLike] = useState('all');
  const [pageTotal, setPageTotal] = useState(0);

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handchanceCliente = (id) => {
    navigate(`/vendedor/calculoProduto/${id}`);
  };

  const handleChangeVendedor = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVendedor(event.target.value);
  };

  const handleNovoCliente = () => {
    navigate('/vendedor/cadastroCliente');
  };
  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };

  return (
    <Stack spacing={2} width="100%">
      <SelectVendedor
        user={user}
        vendedor={vendedor}
        handleChangeVendedor={handleChangeVendedor}
        handleLike={handleLike}
      />
      <TabelaClientes
        vendedor={vendedor}
        limit={limit}
        page={page}
        like={like}
        setPageTotal={setPageTotal}
        handchanceCliente={handchanceCliente}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          p: 1,
          m: 1,
        }}
      >
        {pageTotal > 1 && (
          <>
            <div>
              Apresentando {page} de {pageTotal} resultados
            </div>
            <PaginationComponent count={pageTotal} page={page} onChange={handleChangePage} />
          </>
        )}
        <ButtonPrimary label={'+ NOVO CLIENTE'} typeSubmit={false} onClick={() => handleNovoCliente()} />
      </Box>
    </Stack>
  );
};

export default ListaClientes;
